<script lang="ts">
	import { real_id } from 'src/helpers/interface_helpers';

	//Serivces
	import { postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Checkbox, toast } from '@Shelly/shelly-design-system';

	export let device;

	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	let checked = settings.led_status_disable;
	let cache = checked;
	let loading = false;

	const toggleLight = () => {
		checked = !checked;
	};
	const setLight = async () => {
		if (cache !== checked) {
			loading = true;
			const res = await postReq(`/device/${device.category}/settings/door_sensor_led`, {
				id: device.id,
				enabled: checked ? 0 : 1,
			});

			if (res.isok) {
				settings.led_status_disable = checked;
				devices_settings.update_devices_settings(device.id, settings);
				toast.open({
					type: 'success',
					title: $format('setting_scc_saved_toast'),
				});
				cache = checked;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				checked = cache;
			}
			loading = false;
		}
	};
</script>

<Checkbox size="m" {checked} on:click={toggleLight} id="checkbox-mxxxzo5"
	>{$format('led_light_control_description', {
		default: 'Enable/Disable devices led.',
	})}</Checkbox
>
<Button {loading} size="m" width="full" on:click={setLight}>{$format('button_save')}</Button>
